import React, { useState } from "react";
import "./JobRecruitmentForm.css";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaBriefcase,
  FaFileUpload,
} from "react-icons/fa";

const JobRecruitmentForm = () => {
  const [step, setStep] = useState(1);
  const [direction, setDirection] = useState("next");
  const [showPopup, setShowPopup] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    department: "",
    experience: "",
    coverLetter: "",
    resume: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files[0] : value,
    }));
  };

  const nextStep = () => {
    setDirection("next");
    setStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setDirection("back");
    setStep((prev) => prev - 1);
  };

  // ✅ Submit handler
  const handleSubmit = (e) => {
    e.preventDefault(); // prevent full reload
    setShowPopup(true); // show popup
    e.target.submit(); // submit form to Salesforce hidden iframe
  };

  // ✅ Redirect once Salesforce submission finishes
  const handleIframeLoad = () => {
    if (showPopup) {
      window.location.href = "/"; // redirect home immediately
    }
  };

  return (
    <div className="job-form-container">
      {/* Progress bar */}
      <div className="progress-container">
        <div className={`step ${step >= 1 ? "active" : ""}`}>1</div>
        <div className={`line ${step >= 2 ? "active" : ""}`}></div>
        <div className={`step ${step >= 2 ? "active" : ""}`}>2</div>
        <div className={`line ${step >= 3 ? "active" : ""}`}></div>
        <div className={`step ${step >= 3 ? "active" : ""}`}>3</div>
        <div className={`line ${step >= 4 ? "active" : ""}`}></div>
        <div className={`step ${step >= 4 ? "active" : ""}`}>4</div>
      </div>

      <h2>Job Recruitment Form</h2>

      {/* Salesforce Web-to-Lead form */}
      <form
        action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DgK000004ayct"
        method="POST"
        target="hidden_iframe"
        onSubmit={handleSubmit}
      >
        {/* Salesforce hidden fields */}
        <input type="hidden" name="oid" value="00DgK000004ayct" />
        <input type="hidden" name="retURL" value="/" />

        <div className={`form-slide ${direction}`}>
          {/* Step 1 - Personal Info */}
          {step === 1 && (
            <>
              <div className="form-group input-icon">
                <FaUser />
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div className="form-group input-icon">
                <FaEnvelope />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="form-group input-icon">
                <FaPhone />
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                  required
                />
              </div>

              <button type="button" className="submit-btn" onClick={nextStep}>
                Next →
              </button>
            </>
          )}

          {/* Step 2 - Job Details */}
          {step === 2 && (
            <>
              <div className="form-group input-icon">
                <FaBriefcase />
                <select
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select department</option>
                  <option value="engineering">Engineering</option>
                  <option value="marketing">Marketing</option>
                  <option value="hr">HR</option>
                  <option value="finance">Finance</option>
                </select>
              </div>

              <div className="form-group radio-group">
                <label>
                  <input
                    type="radio"
                    name="experience"
                    value="fresher"
                    checked={formData.experience === "fresher"}
                    onChange={handleChange}
                    required
                  />
                  Fresher
                </label>
                <label>
                  <input
                    type="radio"
                    name="experience"
                    value="1-3"
                    checked={formData.experience === "1-3"}
                    onChange={handleChange}
                  />
                  1-3 Years
                </label>
                <label>
                  <input
                    type="radio"
                    name="experience"
                    value="3-5"
                    checked={formData.experience === "3-5"}
                    onChange={handleChange}
                  />
                  3-5 Years
                </label>
                <label>
                  <input
                    type="radio"
                    name="experience"
                    value="5+"
                    checked={formData.experience === "5+"}
                    onChange={handleChange}
                  />
                  5+ Years
                </label>
              </div>

              <div className="form-group">
                <textarea
                  name="coverLetter"
                  value={formData.coverLetter}
                  onChange={handleChange}
                  placeholder="Write your cover letter here..."
                  rows="4"
                ></textarea>
              </div>

              <div className="button-group">
                <button type="button" className="back-btn" onClick={prevStep}>
                  ← Back
                </button>
                <button type="button" className="submit-btn" onClick={nextStep}>
                  Next →
                </button>
              </div>
            </>
          )}

          {/* Step 3 - Upload */}
          {step === 3 && (
            <>
              <div className="form-group input-icon">
                <FaFileUpload />
                <input
                  type="file"
                  name="resume"
                  onChange={handleChange}
                  accept=".pdf,.doc,.docx"
                  required
                />
              </div>

              <div className="button-group">
                <button type="button" className="back-btn" onClick={prevStep}>
                  ← Back
                </button>
                <button type="button" className="submit-btn" onClick={nextStep}>
                  Next →
                </button>
              </div>
            </>
          )}

          {/* Step 4 - Review */}
          {step === 4 && (
            <>
              <div className="review-section">
                <h3>Review Your Details</h3>
                <ul>
                  <li><strong>Name:</strong> {formData.fullName}</li>
                  <li><strong>Email:</strong> {formData.email}</li>
                  <li><strong>Phone:</strong> {formData.phone}</li>
                  <li><strong>Department:</strong> {formData.department}</li>
                  <li><strong>Experience:</strong> {formData.experience}</li>
                  <li><strong>Cover Letter:</strong> {formData.coverLetter}</li>
                  <li>
                    <strong>Resume:</strong>{" "}
                    {formData.resume ? formData.resume.name : "Not uploaded"}
                  </li>
                </ul>
              </div>

              <div className="button-group">
                <button type="button" className="back-btn" onClick={prevStep}>
                  ← Back
                </button>
                <button type="submit" className="submit-btn">
                  Submit
                </button>
              </div>
            </>
          )}
        </div>
      </form>

      {/* Hidden iframe for Salesforce response */}
      <iframe
        name="hidden_iframe"
        style={{ display: "none" }}
        onLoad={handleIframeLoad}
      ></iframe>

      {/* Thank You Popup */}
      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <h3>🎉 Thank You!</h3>
            <p>Your application has been submitted successfully.</p>
            <small>Redirecting to homepage...</small>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobRecruitmentForm;
